import { produce } from 'immer';
import { makeVar, ReactiveVar } from '@apollo/client';
import { Updater, getDraftedUpdater, registerImmerFunctions } from './common';

export interface ImmerReactiveVar<T> extends ReactiveVar<T> {
  (): T;
  (updater: Updater<T>): T;
  reset: () => T;
}

export function makeImmerVar<T>(initialValue: T) {
  const reactiveVar = makeVar(initialValue);
  const immerReactiveVar = ((...args: [] | [Updater<T>]) => {
    if (args.length === 0) {
      return reactiveVar();
    }
    const [updater] = args;
    const draftedUpdater = getDraftedUpdater(updater, produce);
    const updatedValue = draftedUpdater(reactiveVar());
    return reactiveVar(updatedValue);
  }) as ImmerReactiveVar<T>;
  registerImmerFunctions(immerReactiveVar, reactiveVar, initialValue);
  return immerReactiveVar;
}
